import { useLocation, WindowLocation } from '@reach/router';
import useSelectedAccountParams from '../hooks/useSelectedAccountParams';
import { getFromStorage } from '../util/storage-utils';

type GTMUserData = {};

export type GTMSessionData = {
  sessionId?: String; // unique session id
  sessionStartTime?: String; // start time of session
};

export type GTMPageData = {
  pageName: String; // page title
  siteSection?: String; // L1 navigation or first subdirectory
  siteSubSection?: String; // L2 navigation or second subdirectory
  journeyName?: String; // name of journey associated with the page
  subJourneyName?: String; // name of subjourney associated with the page
  pageTime: String; // string of timestamp of when page was loaded
};

export type GTMActionData = {
  actionLocation: String; // location of acction (nav, content, footer, etc.)
  actionType: String; // type of action (link click, button, form input, exit link, pdf download)
  actionLabel: String; // label used to define the action (click text)
  actionTime: String; // string of time stamp of when action occurred
  actionElement: String; // link, button, input field, accordian, radio button
  actionSubType: String; // click, hover, scroll, open, close
  actionOutcome: String; // exit, download, submit, nav
  outage_rpt?: Number; // 1 if outage reported, else 0 // Special case for triggering the survey - avoid adding journey-specific values here
};

export type GTMData = {
  sessionData?: GTMSessionData;
  pageData?: GTMPageData;
  actionData?: GTMActionData;
};

export type GTMModalVisibilityData = {
  page: string;
  siteSection: string;
  isVisible: boolean;
};

export default () => {
  const location = useLocation();
  const { accountNumber } = useSelectedAccountParams();

  const postGTMData = (data: GTMData) => {
    const personID = getFromStorage('gtmpId');

    console.log('postGTMData:', 'data:', data);

    if (typeof window !== 'undefined') {
      window.dataLayer?.push({
        pgepersonid: personID ? personID : undefined,
        pgeaccount: accountNumber,
        usertype: undefined, //TODO: Needs to be added
        userzipcode: undefined, //TODO: Needs to be added
        sessionid: undefined, //TODO: Needs to be added
        sessionstarttime: undefined, //TODO: Needs to be added
        loggedinstate: personID ? 'loggedIn' : 'loggedOut',
        pageurl: location?.pathname,
        pagename: data.pageData?.pageName,
        sitesection: data.pageData?.siteSection,
        sitesubsection: data.pageData?.siteSubSection,
        pagesecure: personID ? 'secure' : 'public',
        journeyname: data.pageData?.journeyName,
        pagetime: data.pageData?.pageTime,
        ...data.actionData,
      });

      //Resetting the data layer variables is required to avoid duplicating issue
      window.dataLayer?.push(function(this: any) {
        // eslint-disable-next-line
        this.reset();
      });
    }
  };

  const postGTMModalVisibilityData = (data: GTMModalVisibilityData) => {
    const pageDataOutages: GTMPageData = {
      pageName: data.page,
      siteSection: data.siteSection,
      siteSubSection: data.page,
      journeyName: undefined,
      subJourneyName: undefined,
      pageTime: new Date().toISOString(),
    };

    postGTMData({
      pageData: pageDataOutages,
      actionData: {
        actionLocation: 'modal',
        actionType: 'modal visibility',
        actionLabel: data.isVisible ? 'visible' : 'hidden',
        actionTime: new Date().toISOString(),
        actionElement: 'modal',
        actionSubType: 'click',
        actionOutcome: 'open or close',
      },
    });
  };

  return { postGTMData, postGTMModalVisibilityData };
};
